// extracted by mini-css-extract-plugin
module.exports = {"container":"SigninLayout_container__MkPOp","button":"SigninLayout_button__iXwfu"};